import React from 'react';
export function useOutsideClick(ref, handler) {
    React.useEffect(function () {
        var _a;
        var handleOutsideClick = function (event) {
            var element = ref === null || ref === void 0 ? void 0 : ref.current;
            if (element && !element.contains(event.target)) {
                handler(event);
            }
        };
        (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', handleOutsideClick);
        return function () {
            var _a;
            (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
}
//# sourceMappingURL=useOutsideClick.js.map